import { render, staticRenderFns } from "./MailAccount.vue?vue&type=template&id=0c7a5dac&scoped=true"
import script from "./MailAccount.vue?vue&type=script&lang=js"
export * from "./MailAccount.vue?vue&type=script&lang=js"
import style0 from "./MailAccount.vue?vue&type=style&index=0&id=0c7a5dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7a5dac",
  null
  
)

export default component.exports